module.exports = __webpack_public_path__ + "static/fonts/FiraSans-LightItalic.09feeaf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FiraSans/FiraSans-LightItalic.ttf
// module id = 1157
// module chunks = 5